export let miz_otherVideos = {}; // که یادت باشه مجموعه‌های دیگه هم از فیلم‌ها می‌تونی داشته باشی

export let miz_videos = {
  listePayeha: [7, 8, 9],
  payeye7: {
    shomareyeTartibiyePaye: 'هفتم',
    tedadeFaslha: 9,
    fasle1: {
      onvaneFasl: 'راهبردهای حل مسئله',
      darse1: {
        onvaneDars: 'کلّی!',
        ghesmate1: { onvan: 'راهبرد الگوسازی', shenase: 'oTlYd' },
        ghesmate2: { onvan: 'راهبرد حذف حالت های نامطلوب', shenase: 'C0PEb' },
        ghesmate3: { onvan: 'راهبرد الگویابی', shenase: '9JzB6' },
        ghesmate4: { onvan: 'راهبرد حدس و آزمایش', shenase: 's3B0e' },
        ghesmate5: { onvan: 'راهبرد زیر مسئله', shenase: 'bjgmW' },
        ghesmate6: { onvan: 'راهبرد حل مسئله ساده تر', shenase: 'QkhUW' },
        ghesmate7: { onvan: 'راهبرد روش های نمادین', shenase: '5oFxk' },
        ghesmate8: { onvan: 'مرور راهبردها 1', shenase: 'QJdNM' },
        ghesmate9: { onvan: 'مرور راهبردها 2', shenase: 'mvxXL' },
        ghesmate10: { onvan: 'مرور راهبردها 3', shenase: '760GS' },
        ghesmate11: { onvan: 'مرور راهبردها 4', shenase: 'KGVLq' },
        ghesmate12: { onvan: 'مرور راهبردها 5', shenase: 'Lg5bk' },
        ghesmate13: { onvan: 'مرور راهبردها 6', shenase: 'Ml6AD' },
        ghesmate14: { onvan: 'مرور راهبردها 7', shenase: '1CM6V' },
      },
    },
    fasle2: {
      onvaneFasl: 'عددهای صحیح',

      darse4: {
        onvaneDars: 'ضرب و تقسیم عددهای صحیح',
        ghesmate1: { onvan: 'ضرب و تقسیم عددهای صحیح 1', shenase: 'AlgnW' },
        ghesmate2: { onvan: 'ضرب و تقسیم عددهای صحیح 2', shenase: 'wqWsP' },
        ghesmate3: { onvan: 'ضرب و تقسیم عددهای صحیح 3', shenase: 'QNHcJ' },
        ghesmate4: { onvan: 'ضرب و تقسیم عددهای صحیح 4', shenase: 'NbOIy' },
        ghesmate5: { onvan: 'ضرب و تقسیم عددهای صحیح 5', shenase: 'ilrBH' },
        ghesmate6: { onvan: 'ضرب و تقسیم عددهای صحیح 6', shenase: 'igN8I' },
        ghesmate7: { onvan: 'ضرب و تقسیم عددهای صحیح 7', shenase: 'xVPCn' },
        ghesmate8: { onvan: 'ضرب و تقسیم عددهای صحیح 8', shenase: 'VAExj' },
        ghesmate9: { onvan: 'ضرب و تقسیم عددهای صحیح 9', shenase: 'MKgRj' },
        ghesmate10: { onvan: 'ضرب و تقسیم عددهای صحیح 10', shenase: '5hZEO' },
        ghesmate11: { onvan: 'ضرب و تقسیم عددهای صحیح 11', shenase: '12VkU' },
        ghesmate12: { onvan: 'ضرب و تقسیم عددهای صحیح 12', shenase: 'NpzEV' },
        ghesmate13: { onvan: 'ضرب و تقسیم عددهای صحیح 13', shenase: 'ZgDWq' },
      },

      darse3: {
        onvaneDars: 'جمع و تفریق عددهای صحیح 2',
        ghesmate6: { onvan: 'جمع و تفریق عددهای صحیح 12', shenase: 'xuW52' },
        ghesmate5: { onvan: 'جمع و تفریق عددهای صحیح 11', shenase: 'bXnTB' },
        ghesmate4: { onvan: 'جمع و تفریق عددهای صحیح 10', shenase: 'gewHB' },
        ghesmate3: { onvan: 'جمع و تفریق عددهای صحیح 9', shenase: 'pXMRW' },
        ghesmate2: { onvan: 'جمع و تفریق عددهای صحیح 8', shenase: 'd5QCi' },
        ghesmate1: { onvan: 'جمع و تفریق عددهای صحیح 7', shenase: 'tMRBH' },
      },

      darse2: {
        onvaneDars: 'جمع و تفریق عددهای صحیح 1',
        ghesmate6: { onvan: 'جمع و تفریق عددهای صحیح 5', shenase: 'VqU4g' },
        ghesmate5: { onvan: 'جمع و تفریق عددهای صحیح 4', shenase: 'VDfUz' },
        ghesmate4: { onvan: 'جمع و تفریق عددهای صحیح 3', shenase: 'xtf2C' },
        ghesmate3: { onvan: 'جمع و تفریق عددهای صحیح 3', shenase: 'BGwKl' },
        ghesmate2: { onvan: 'جمع و تفریق عددهای صحیح 2', shenase: 'H8Uvz' },
        ghesmate1: { onvan: 'جمع و تفریق عددهای صحیح 1', shenase: 'taB0G' },
      },

      darse1: {
        onvaneDars: 'عددهای صحیح',
        ghesmate6: { onvan: 'عددهای صحیح 6', shenase: 'OvKCX' },
        ghesmate5: { onvan: 'عددهای صحیح 5', shenase: 'bANV4' },
        ghesmate4: { onvan: 'عددهای صحیح 4', shenase: 'f0Zbs' },
        ghesmate3: { onvan: 'عددهای صحیح 3', shenase: 'RcAYt' },
        ghesmate2: { onvan: 'عددهای صحیح 2', shenase: 'WD0aq' },
        ghesmate1: { onvan: 'عددهای صحیح 1', shenase: 'bJE6H' },
      },
    },
    fasle3: {
      onvaneFasl: 'جبر و معادله',

      darse4: {
        onvaneDars: 'معادله',
        ghesmate4: { onvan: 'معادله 4', shenase: 'o8X2j' },
        ghesmate3: { onvan: 'معادله 3', shenase: 'INxjV' },
        ghesmate2: { onvan: 'معادله 2', shenase: 'RCjdT' },
        ghesmate1: { onvan: 'معادله 1', shenase: 'vTDsf' },
      },

      darse3: {
        onvaneDars: 'مقدار عددی عبارت جبری',
        ghesmate1: { onvan: 'مقدار عددی عبارت جبری', shenase: 'KiZ94' },
      },

      darse2: {
        onvaneDars: 'عبارت‌های جبری',
        ghesmate5: { onvan: 'عبارت های جبری 5', shenase: 'jA7GW' },
        ghesmate4: { onvan: 'عبارت های جبری 4', shenase: '0X9hZ' },
        ghesmate3: { onvan: 'عبارت های جبری 3', shenase: 'gSIZU' },
        ghesmate2: { onvan: 'عبارت های جبری 2', shenase: 'mR5Tt' },
        ghesmate1: { onvan: 'عبارت های جبری 1', shenase: 'frlnb' },
      },

      darse1: {
        onvaneDars: 'الگوهای عددی',
        ghesmate5: { onvan: 'الگوهای عددی 5', shenase: 'OYQjr' },
        ghesmate4: { onvan: 'الگوهای عددی 4', shenase: 'dsUlL' },
        ghesmate3: { onvan: 'الگوهای عددی 3', shenase: 'QZbMS' },
        ghesmate2: { onvan: 'الگوهای عددی 2', shenase: 'ksK8R' },
        ghesmate1: { onvan: 'الگوهای عددی 1', shenase: '6qCJg' },
      },
    },
    fasle4: {
      onvaneFasl: 'هندسه و استدلال',

      darse4: {
        onvaneDars: 'شکل‌های هم‌نهشت',
        ghesmate1: { onvan: 'شکل های هم نهشت', shenase: '6zYnX' },
      },

      darse3: {
        onvaneDars: 'انتقال، تقارن و دوران',
        ghesmate2: { onvan: 'انتقال، تقارن و دوران 2', shenase: 'vduZ2' },
        ghesmate1: { onvan: 'انتقال، تقارن، دوران 1', shenase: 'qrE0W' },
      },

      darse2: {
        onvaneDars: 'روابط بین زاویه‌ها',
        ghesmate4: { onvan: 'روابط بین زاویه ها 4', shenase: 'Oauf2' },
        ghesmate3: { onvan: 'روابط بین زاویه ها 3', shenase: '8yCFX' },
        ghesmate2: { onvan: 'روابط بین زاویه ها 2', shenase: '9ACZB' },
        ghesmate1: { onvan: 'روابط بین زاویه ها 1', shenase: 'W9YiX' },
      },

      darse1: {
        onvaneDars: 'روابط بین پاره‌خط‌ها',
        ghesmate1: { onvan: 'روابط بین پاره خط ها', shenase: 'Sy3ih' },
      },
    },
    fasle5: {
      onvaneFasl: 'شمارنده‌ها و اعداد اول',

      darse4: {
        onvaneDars: 'ک م م',
        ghesmate3: { onvan: 'ک م م 3', shenase: '7DO0W' },
        ghesmate2: { onvan: 'ک م م 2', shenase: 'S5gBz' },
        ghesmate1: { onvan: 'ک م م 1', shenase: 'VIdTA' },
      },

      darse3: {
        onvaneDars: 'ب م م',
        ghesmate3: { onvan: 'ب م م 3', shenase: 'Hek6N' },
        ghesmate2: { onvan: 'ب م م 2', shenase: '2W5dL' },
        ghesmate1: { onvan: 'ب م م 1', shenase: 'IvqGg' },
      },

      darse2: {
        onvaneDars: 'شمارنده‌ی اول',
        ghesmate2: { onvan: 'شمارنده ی اول 2', shenase: 'Hl6km' },
        ghesmate1: { onvan: 'شمارنده ی اول 1', shenase: 'hULeu' },
      },

      darse1: {
        onvaneDars: 'عدد اول',
        ghesmate4: { onvan: 'عدد اول 4', shenase: '2p8QC' },
        ghesmate3: { onvan: 'عدد اول 3', shenase: 'YP5Qj' },
        ghesmate2: { onvan: 'عدد اول 2', shenase: 'QRHtZ' },
        ghesmate1: { onvan: 'عدد اول 1', shenase: 'Zbraq' },
      },
    },
    fasle6: {
      onvaneFasl: 'سطح و حجم',

      darse4: {
        onvaneDars: 'حجم و سطح',
        ghesmate7: { onvan: 'حجم و سطح 7', shenase: 'BanjO' },
        ghesmate6: { onvan: 'حجم و سطح 6', shenase: 'FwvMD' },
        ghesmate5: { onvan: 'حجم و سطح 5', shenase: '5L1Tm' },
        ghesmate4: { onvan: 'حجم و سطح 4', shenase: 'wVPov' },
        ghesmate3: { onvan: 'حجم و سطح 3', shenase: 'Rdail' },
        ghesmate2: { onvan: 'حجم و سطح 2', shenase: 'W8Vyb' },
        ghesmate1: { onvan: 'حجم و سطح 1', shenase: '56q7a' },
      },

      darse3: {
        onvaneDars: 'مساحت جانبی و کل',
        ghesmate1: { onvan: 'مساحت جانبی و کل 1', shenase: 'hawfz' },
      },

      darse2: {
        onvaneDars: 'محاسبه‌ی حجم‌های منشوری',
        ghesmate1: { onvan: 'محاسبه حجم های منشوری 1', shenase: 'PJ3xR' },
      },

      darse1: {
        onvaneDars: 'حجم‌های هندسی',
        ghesmate2: { onvan: 'حجم های هندسی 2', shenase: 'PyXot' },
        ghesmate1: { onvan: 'حجم های هندسی 1', shenase: '8cxvI' },
      },

    },
    fasle7: {
      onvaneFasl: 'توان و جذر',

      darse4: {
        onvaneDars: 'جذر و ریشه',
        ghesmate4: { onvan: 'جذر و ریشه 4', shenase: 'xhL0p' },
        ghesmate3: { onvan: 'جذر و ریشه 3', shenase: 'xVr5j' },
        ghesmate2: { onvan: 'جذر و ریشه 2', shenase: 'JADaf' },
        ghesmate1: { onvan: 'جذر و ریشه 1', shenase: 'aKPDB' },
      },

      darse3: {
        onvaneDars: 'ساده‌کردن عبارت‌های توان‌دار',
        ghesmate6: { onvan: 'ساده کردن عبارت های توان دار 6', shenase: 'KvQex' },
        ghesmate5: { onvan: 'ساده کردن عبارت های توان دار 5', shenase: 'oL6Pc' },
        ghesmate4: { onvan: 'ساده کردن عبارت های توان دار 4', shenase: 'Py46g' },
        ghesmate3: { onvan: 'ساده کردن عبارت های توان دار 3', shenase: 'U1IcE' },
        ghesmate2: { onvan: 'ساده کردن عبارت های توان دار 2', shenase: '2A1uc' },
        ghesmate1: { onvan: 'ساده کردن عبارت های توان دار 1', shenase: 'FtKde' },
      },

      darse2: {
        onvaneDars: 'محاسبه‌ی عبارت توان‌دار',
        ghesmate8: { onvan: 'محاسبه ی عبارت توان دار 8', shenase: 'LhPoy' },
        ghesmate7: { onvan: 'محاسبه ی عبارت توان دار 7', shenase: 'ABaVN' },
        ghesmate6: { onvan: 'محاسبه ی عبارت توان دار 6', shenase: 'UKNWS' },
        ghesmate5: { onvan: 'محاسبه ی عبارت توان دار 5', shenase: 'As6gK' },
        ghesmate4: { onvan: 'محاسبه ی عبارت توان دار 4', shenase: 'T2ArC' },
        ghesmate3: { onvan: 'محاسبه ی عبارت توان دار 3', shenase: 'f5yDe' },
        ghesmate2: { onvan: 'محاسبه ی عبارت توان دار 2', shenase: 'wyopu' },
        ghesmate1: { onvan: 'محاسبه ی عبارت توان دار 1', shenase: '3chOb' },
      },

      darse1: {
        onvaneDars: 'تعریف توان',
        ghesmate9: { onvan: 'تعریف توان 9', shenase: 'eIgow' },
        ghesmate8: { onvan: 'تعریف توان 8', shenase: 'o8S3v' },
        ghesmate7: { onvan: 'تعریف توان 7', shenase: 'JQn63' },
        ghesmate6: { onvan: 'تعریف توان 6', shenase: 'xEGky' },
        ghesmate5: { onvan: 'تعریف توان 5', shenase: 'zvmn3' },
        ghesmate4: { onvan: 'تعریف توان 4', shenase: '2LY5b' },
        ghesmate3: { onvan: 'تعریف توان 3', shenase: '2Px7S' },
        ghesmate2: { onvan: 'تعریف توان 2', shenase: 'sPeLr' },
        ghesmate1: { onvan: 'تعریف توان 1', shenase: '3dFIN' },
      },

    },
    fasle8: {
      onvaneFasl: 'بردار و مختصات',

      darse4: {
        onvaneDars: 'بردار انتقال',
        ghesmate6: { onvan: 'بردار انتقال 6', shenase: 'A7vy2' },
        ghesmate5: { onvan: 'بردار انتقال 5', shenase: '13U8E' },
        ghesmate4: { onvan: 'بردار انتقال 4', shenase: 'Ab2Ch' },
        ghesmate3: { onvan: 'بردار انتقال 3', shenase: '9bcns' },
        ghesmate2: { onvan: 'بردار انتقال 2', shenase: 'KER9I' },
        ghesmate1: { onvan: 'بردار انتقال 1', shenase: 'gZ3AC' },
      },

      darse3: {
        onvaneDars: 'مختصات',
        ghesmate4: { onvan: 'مختصات 4', shenase: 'WUG1k' },
        ghesmate3: { onvan: 'مختصات 3', shenase: 'V1unX' },
        ghesmate2: { onvan: 'مختصات 2', shenase: 'yBmAz' },
        ghesmate1: { onvan: 'مختصات 1', shenase: 'nIurg' },
      },

      darse2: {
        onvaneDars: 'بردارهای مساوی و قرینه',
        ghesmate3: { onvan: 'بردارهای مساوی و قرینه 3', shenase: 'xNcqr' },
        ghesmate2: { onvan: 'بردارهای مساوی و قرینه 2', shenase: 'SpgQ3' },
        ghesmate1: { onvan: 'بردارهای مساوی و قرینه 1', shenase: 'vZao1' },
      },

      darse1: {
        onvaneDars: 'پاره‌خط جهت‌دار',
        ghesmate1: { onvan: 'پاره خط جهت دار', shenase: 'xmVE0' },
      },

    },
    fasle9: {
      onvaneFasl: 'آمار و احتمال',

      darse4: {
        onvaneDars: 'احتمال و تجربه',
        ghesmate1: { onvan: 'احتمال و تجربه', shenase: 'OUWsy' },
      },

      darse3: {
        onvaneDars: 'احتمال یا اندازه‌گیری شانس',
        ghesmate1: { onvan: 'احتمال یا اندازه گیری شانس', shenase: 'v8tNs' },
      },

      darse2: {
        onvaneDars: 'نمودارها و تفسیر نتیجه‌ها',
        ghesmate1: { onvan: 'نمودارها و تفسیر نتیجه ها', shenase: '6hFmC' },
      },

      darse1: {
        onvaneDars: 'جمع‌آوری و نمایش داده‌ها',
        ghesmate1: { onvan: 'جمع آوری و نمایش داده ها', shenase: 'G1nVT' },
      },

    },
  },
  payeye8: {
    shomareyeTartibiyePaye: 'هشتم',
    tedadeFaslha: 9,

    fasle9: {
      onvaneFasl: 'دایره',

      darse3: {
        onvaneDars: 'زاویه‌های محاطی',
        ghesmate1: { onvan: 'زاویه های محاطی', shenase: '0WlpM', },
      },
      darse2: {
        onvaneDars: 'زاویه‌های مرکزی',
        ghesmate1: { onvan: 'زاویه های مرکزی', shenase: 'WVxge', },
      },
      darse1: {
        onvaneDars: 'خط و دایره',
        ghesmate1: { onvan: 'خط و دایره', shenase: '4rvnW', },
      },

    },

    fasle8: {
      onvaneFasl: 'آمار و احتمال',

      darse4: {
        onvaneDars: 'بررسی حالت‌های ممکن',
        ghesmate1: { onvan: 'بررسی حالت های ممکن', shenase: 'GtdAV', },
      },
      darse3: {
        onvaneDars: 'احتمال یا اندازه‌گیری شانس',
        ghesmate1: { onvan: 'احتمال یا اندازه گیری شانس', shenase: 'FwmSb', },
      },
      darse2: {
        onvaneDars: 'میانگین داده‌ها',
        ghesmate1: { onvan: 'میانگین داده ها', shenase: 'p16I7', },
      },
      darse1: {
        onvaneDars: 'دسته‌بندی داده‌ها',
        ghesmate1: { onvan: 'دسته بندی داده ها', shenase: 'g0hsQ', },
      },
    },

    fasle7: {
      onvaneFasl: 'توان و جذر',

      darse5: {
        onvaneDars: 'خواص ضرب و تقسیم رادیکال‌ها',
        ghesmate8: { onvan: 'خواص ضرب و تقسیم رادیکال ها 8', shenase: 'gDicy', },
        ghesmate7: { onvan: 'خواص ضرب و تقسیم رادیکال ها 7', shenase: 'jW07U', },
        ghesmate6: { onvan: 'خواص ضرب و تقسیم رادیکال ها 6', shenase: 'Iw9Yz', },
        ghesmate5: { onvan: 'خواص ضرب و تقسیم رادیکال ها 5', shenase: 'Ty6nj', },
        ghesmate4: { onvan: 'خواص ضرب و تقسیم رادیکال ها 4', shenase: 'JtThE', },
        ghesmate3: { onvan: 'خواص ضرب و تقسیم رادیکال ها 3', shenase: 'VyqAg', },
        ghesmate2: { onvan: 'خواص ضرب و تقسیم رادیکال ها 2', shenase: 'nk2yu', },
        ghesmate1: { onvan: 'خواص ضرب و تقسیم رادیکال ها 1', shenase: 'ouiaN', },
      },
      darse4: {
        onvaneDars: 'نمایش اعداد رادیکالی روی محور اعداد',
        ghesmate1: { onvan: 'نمایش اعداد رادیکالی روی محور اعداد', shenase: 'ZwkEQ', },
      },
      darse3: {
        onvaneDars: 'جذر تقریبی',
        ghesmate3: { onvan: 'جذر تقریبی 3', shenase: 'rbMBG', },
        ghesmate2: { onvan: 'جذر تقریبی 2', shenase: '0hTAo', },
        ghesmate1: { onvan: 'جذر تقریبی 1', shenase: 'nAzBY', },
      },
      darse2: {
        onvaneDars: 'تقسیم اعداد توان‌دار',
        ghesmate8: { onvan: 'تقسیم اعداد توان دار 8', shenase: 'Uia4F', },
        ghesmate7: { onvan: 'تقسیم اعداد توان دار 7', shenase: 'Lp4xu', },
        ghesmate6: { onvan: 'تقسیم اعداد توان دار 6', shenase: 'cR5nF', },
        ghesmate5: { onvan: 'تقسیم اعداد توان دار 5', shenase: 'yd4w7', },
        ghesmate4: { onvan: 'تقسیم اعداد توان دار 4', shenase: 'zpgiV', },
        ghesmate3: { onvan: 'تقسیم اعداد توان دار 3', shenase: 'MTkY1', },
        ghesmate2: { onvan: 'تقسیم اعداد توان دار 2', shenase: 'q1Lcv', },
        ghesmate1: { onvan: 'تقسیم اعداد توان دار 1', shenase: 'VjXMt', },
      },
      darse1: {
        onvaneDars: 'توان',
        ghesmate7: { onvan: 'توان 7', shenase: 'cEsIJ', },
        ghesmate6: { onvan: 'توان 6', shenase: 'SZrxj', },
        ghesmate5: { onvan: 'توان 5', shenase: 'CcNmY', },
        ghesmate4: { onvan: 'توان 4', shenase: 'nJjsA', },
        ghesmate3: { onvan: 'توان 3', shenase: 'PdHnA', },
        ghesmate2: { onvan: 'توان 2', shenase: 'gXirV', },
        ghesmate1: { onvan: 'توان 1', shenase: '3LQZy', },
      },
    },

    fasle6: {
      onvaneFasl: 'مثلث',

      darse4: {
        onvaneDars: 'هم‌نهشتی مثلث‌های قائم‌الزاویه',
        ghesmate1: { onvan: 'همنهشتی مثلث های قائم الزاویه', shenase: 'Y8Zj2', },
      },

      darse3: {
        onvaneDars: 'مثلث‌های هم‌نهشت',
        ghesmate1: { onvan: 'مثلث های هم نهشت', shenase: 'EFRVc', },
      },

      darse2: {
        onvaneDars: 'شکل‌های هم‌نهشت',
        ghesmate5: { onvan: 'شکل های هم نهشت 5', shenase: 'WScuw', },
        ghesmate4: { onvan: 'شکل های هم نهشت 4', shenase: 'tLR4K', },
        ghesmate3: { onvan: 'شکل های هم نهشت 3', shenase: 'f0nNX', },
        ghesmate2: { onvan: 'شکل های هم نهشت 2', shenase: '0lpTq', },
        ghesmate1: { onvan: 'شکل های هم نهشت 1', shenase: 'ZHOKe', },
      },

      darse1: {
        onvaneDars: 'رابطه‌ی فیثاغورس',
        ghesmate9: { onvan: 'رابطه فیثاغورس 9', shenase: 'ZXohY', },
        ghesmate8: { onvan: 'رابطه فیثاغورس 8', shenase: '8fm13', },
        ghesmate7: { onvan: 'رابطه فیثاغورس 7', shenase: 'eNA1G', },
        ghesmate6: { onvan: 'رابطه فیثاغورس 6', shenase: 'Pf08B', },
        ghesmate5: { onvan: 'رابطه فیثاغورس 5', shenase: 'oOhlu', },
        ghesmate4: { onvan: 'رابطه فیثاعورس 4', shenase: 'icTWt', },
        ghesmate3: { onvan: 'رابطه فیثاغورس 3', shenase: 'hsJBT', },
        ghesmate2: { onvan: 'رابطه فیثاغورس 2', shenase: 'onAp8', },
        ghesmate1: { onvan: 'رابطه فیثاغورس 1', shenase: '4eAqG', },
      },
    },

    fasle5: {
      onvaneFasl: 'بردار و مختصات',

      darse3: {
        onvaneDars: 'بردارهای واحد مختصات',
        ghesmate5: { onvan: 'بردارهای واحد مختصات 5', shenase: 'oLDZU', },
        ghesmate4: { onvan: 'بردارهای واحد مختصات 4', shenase: 'OzdRa', },
        ghesmate3: { onvan: 'بردارهای واحد مختصات 3', shenase: 'aYjKg', },
        ghesmate2: { onvan: 'بردارهای واحد مختصات 2', shenase: '4iszu', },
        ghesmate1: { onvan: 'بردارهای واحد مختصات 1', shenase: 'PEFT1', },
      },
      darse2: {
        onvaneDars: 'ضرب عدد در بردار',
        ghesmate8: { onvan: 'ضرب عدد در بردار 8', shenase: 's6HSk', },
        ghesmate7: { onvan: 'ضرب عدد در بردار 7', shenase: 'O0pJW', },
        ghesmate6: { onvan: 'ضرب عدد در بردار 6', shenase: 'Xpmr7', },
        ghesmate5: { onvan: 'ضرب عدد در بردار 5', shenase: 'w5qTU', },
        ghesmate4: { onvan: 'ضرب عدد در بردار 4', shenase: 'Z54iS', },
        ghesmate3: { onvan: 'ضرب عدد در بردار 3', shenase: 'naDN5', },
        ghesmate2: { onvan: 'ضرب عدد در بردار 2', shenase: '6T9tH', },
        ghesmate1: { onvan: 'ضرب عدد در بردار 1', shenase: 'ct1v7', },
      },
      darse1: {
        onvaneDars: 'جمع بردارها',
        ghesmate7: { onvan: 'جمع بردارها 7', shenase: 'p8Kgh', },
        ghesmate6: { onvan: 'جمع بردارها 6', shenase: 'QSqoz', },
        ghesmate5: { onvan: 'جمع بردارها 5', shenase: 'nhWou', },
        ghesmate4: { onvan: 'جمع بردارها 4', shenase: '76GLt', },
        ghesmate3: { onvan: 'جمع بردارها 3', shenase: 'qrGu9', },
        ghesmate2: { onvan: 'جمع بردارها 2', shenase: 'THDWM', },
        ghesmate1: { onvan: 'جمع بردارها 1', shenase: '1pRe8', },
      },
    },

    fasle4: {
      onvaneFasl: 'جبر و معادله',

      darse4: {
        onvaneDars: 'معادله',
        ghesmate7: { onvan: 'معادله 7', shenase: 'mW2u8', },
        ghesmate6: { onvan: 'معادله 6', shenase: 'sRQLu', },
        ghesmate5: { onvan: 'معادله 5', shenase: 'f21YA', },
        ghesmate4: { onvan: 'معادله 4', shenase: '1k682', },
        ghesmate3: { onvan: 'معادله 3', shenase: 'TSO94', },
        ghesmate2: { onvan: 'معادله 2', shenase: 'xvJyV', },
        ghesmate1: { onvan: 'معادله 1', shenase: 'TZSqm', },
      },
      darse3: {
        onvaneDars: 'تجزیه‌ی عبارت‌های جبری',
        ghesmate7: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 7', shenase: 'XUeqh', },
        ghesmate6: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 6', shenase: '8IZaU', },
        ghesmate5: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 5', shenase: 'l4v3i', },
        ghesmate4: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 4', shenase: 'Wi7dJ', },
        ghesmate3: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 3', shenase: 'WxI3q', },
        ghesmate2: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 2 -', shenase: 'HUovy', },
        ghesmate1: { onvan: 'تجزیه عبارت های جبری (فاکتورگیری) 1', shenase: 'oJadi', },
      },
      darse2: {
        onvaneDars: 'پیداکردن مقدار یک عبارت جبری',
        ghesmate11: { onvan: 'پیدا کردن مقدار عبارت جبری 11', shenase: 'OC8nf', },
        ghesmate10: { onvan: 'پیدا کردن مقدار عبارت جبری 10', shenase: 'bYPH3', },
        ghesmate9: { onvan: 'پیدا کردن مقدار عبارت جبری 9', shenase: '9cML7', },
        ghesmate8: { onvan: 'پیدا کردن مقدار عبارت جبری 8', shenase: 'rinmA', },
        ghesmate7: { onvan: 'پیدا کردن مقدار عبارت جبری 7', shenase: 'HNQOl', },
        ghesmate6: { onvan: 'پیدا کردن مقدار عبارت جبری 6', shenase: '6UNuD', },
        ghesmate5: { onvan: 'پیدا کردن مقدار عبارت جبری 5', shenase: 'SMNcs', },
        ghesmate4: { onvan: 'پیدا کردن مقدار عبارت جبری 4', shenase: 'M9E7O', },
        ghesmate3: { onvan: 'پیدا کردن مقدار عبارت جبری 3', shenase: 'f4HqQ', },
        ghesmate2: { onvan: 'پیدا کردن مقدار عبارت جبری 2', shenase: 'yXwzE', },
        ghesmate1: { onvan: 'پیدا کردن مقدار عبارت جبری 1', shenase: 'REtlV', },
      },
      darse1: {
        onvaneDars: 'ساده‌کردن عبارت‌های جبری',
        ghesmate12: { onvan: 'ساده کردن عبارت های جبری12', shenase: '1yYVj', },
        ghesmate11: { onvan: 'ساده کردن عبارت های جبری11', shenase: 'Credy', },
        ghesmate10: { onvan: 'ساده کردن عبارت های جبری10', shenase: 'cOyEo', },
        ghesmate9: { onvan: 'ساده کردن عبارت های جبری9', shenase: 's3DQT', },
        ghesmate8: { onvan: 'ساده کردن عبارت های جبری8', shenase: 'fNdJM', },
        ghesmate7: { onvan: 'ساده کردن عبارت های جبری7', shenase: 'hQN5X', },
        ghesmate6: { onvan: 'ساده کردن عبارت های جبری6', shenase: 'yZICh', },
        ghesmate5: { onvan: 'ساده کردن عبارت های جبری5', shenase: '1RgI6', },
        ghesmate4: { onvan: 'ساده کردن عبارت های جبری4', shenase: 'I7lrD', },
        ghesmate3: { onvan: 'ساده کردن عبارت های جبری3', shenase: '7Qbri', },
        ghesmate2: { onvan: 'ساده کردن عبارت های جبری2', shenase: '02Cvz', },
        ghesmate1: { onvan: 'ساده کردن عبارت های جبری1', shenase: 'T9F5j', },
      },
    },

    fasle3: {
      onvaneFasl: 'چندضلعی‌ها',

      darse5: {
        onvaneDars: 'زاویه‌های خارجی',
        ghesmate5: { onvan: 'زاویه های خارجی 5', shenase: 'KtPlh', },
        ghesmate4: { onvan: 'زاویه های خارجی 4', shenase: '8XCGH', },
        ghesmate3: { onvan: 'زاویه های خارجی 3', shenase: 'dXncZ', },
        ghesmate2: { onvan: 'زاویه های خارجی 2', shenase: 'BdJ3b', },
        ghesmate1: { onvan: 'زاویه های خارجی 1', shenase: 'zBm5I', },
      },
      darse4: {
        onvaneDars: 'زاویه‌های داخلی',
        ghesmate1: { onvan: 'زاویه های داخلی', shenase: 'RpzLI', },
      },

      darse3: {
        onvaneDars: 'چهارضلعی‌ها',
        ghesmate3: { onvan: 'چهارضلعی ها 3', shenase: 'dFBvz', },
        ghesmate2: { onvan: 'چهارضلعی ها 2', shenase: 'RaG0e', },
        ghesmate1: { onvan: 'چهارضلعی ها 1', shenase: 'nqe9T', },
      },

      darse2: {
        onvaneDars: 'توازی و تعامد',
        ghesmate4: { onvan: 'توازی و تعامد 4', shenase: 'AKxpv', },
        ghesmate3: { onvan: 'توازی و تعامد 3', shenase: 'dbVWl', },
        ghesmate2: { onvan: 'توازی و تعامد 2', shenase: 't2Gbg', },
        ghesmate1: { onvan: 'توازی و تعامد 1', shenase: 'oZqGI', },
      },

      darse1: {
        onvaneDars: 'چندضلعی‌ها و تقارن',
        ghesmate6: { onvan: 'چندضلعی ها و تقارن 6', shenase: 'DCEdr', },
        ghesmate5: { onvan: 'چندضلعی ها و تقارن 5', shenase: 'uGeiv', },
        ghesmate4: { onvan: 'چندضلعی ها و تقارن 4', shenase: '6vpHF', },
        ghesmate3: { onvan: 'چندضلعی ها و تقارن 3', shenase: 'm32y8', },
        ghesmate2: { onvan: 'چندضلعی ها و تقارن 2', shenase: 'ln2yD', },
        ghesmate1: { onvan: 'چندضلعی ها و تقارن 1', shenase: 'Nq9Xs', },
      },

    },

    fasle2: {
      onvaneFasl: 'عددهای اول',

      darse2: {
        onvaneDars: 'تعیین عددهای اول',
        ghesmate3: { onvan: 'تعیین عددهای اول', shenase: '3Epy9', },
        ghesmate2: { onvan: 'روش تقسیم', shenase: 'kXMjd', },
        ghesmate1: { onvan: 'روش غربال', shenase: 'EBomR', },
      },
      darse1: {
        onvaneDars: 'یادآوری عددهای اول',
        ghesmate4: { onvan: 'یادآوری عددهای اول 4', shenase: 'nyZf9', },
        ghesmate3: { onvan: 'یادآوری عددهای اول 3', shenase: 'r8hLS', },
        ghesmate2: { onvan: 'یادآوری عددهای اول 2', shenase: 'VFiT4', },
        ghesmate1: { onvan: 'یادآوری عددهای اول 1', shenase: '0CN4c', },
      },
    },

    fasle1: {
      onvaneFasl: 'عددهای صحیح و گویا',

      darse4: {
        onvaneDars: 'ضرب و تقسیم عددهای گویا',
        ghesmate3: { onvan: 'ضرب و تقسیم عددهای گویا 3', shenase: 'VUzfS', },
        ghesmate2: { onvan: 'ضرب و تقسیم عددهای گویا 2', shenase: 'uDSl2', },
        ghesmate1: { onvan: 'ضرب و تقسیم عددهای گویا 1', shenase: 'umUkJ', },
      },

      darse3: {
        onvaneDars: 'جمع و تفریق عددهای گویا',
        ghesmate4: { onvan: 'جمع و تفریق عددهای گویا 4', shenase: 'vmiYV', },
        ghesmate3: { onvan: 'جمع و تفریق عددهای گویا 3', shenase: '7yTUH', },
        ghesmate2: { onvan: 'جمع و تفریق عددهای گویا 2', shenase: 'WKrtk', },
        ghesmate1: { onvan: 'جمع و تفریق عددهای گویا 1', shenase: 'zwQk2', },
      },

      darse2: {
        onvaneDars: 'معرفی عددهای گویا',
        ghesmate10: { onvan: 'عددهای گویا 10', shenase: 'CD3SL', },
        ghesmate9: { onvan: 'عددهای گویا 9', shenase: 'TVzQw', },
        ghesmate8: { onvan: 'عددهای گویا 8', shenase: 'ZihzJ', },
        ghesmate7: { onvan: 'عددهای گویا 7', shenase: 'P3Fwl', },
        ghesmate6: { onvan: 'عددهای گویا 6', shenase: '7Uzib', },
        ghesmate5: { onvan: 'عددهای گویا 5', shenase: 'mfo8v', },
        ghesmate4: { onvan: 'عددهای گویا 4', shenase: 'DvjXG', },
        ghesmate3: { onvan: 'عددهای گویا 3', shenase: 'CBvIJ', },
        ghesmate2: { onvan: 'عددهای گویا 2', shenase: '51hco', },
        ghesmate1: { onvan: 'عددهای گویا 1', shenase: 'OYzpn', },
      },

      darse1: {
        onvaneDars: 'یادآوری عددهای صحیح',
        ghesmate8: { onvan: 'پر کردن جدول اعداد صحیح', shenase: 'UMQ0a', },
        ghesmate7: { onvan: 'حل یک سوال از کتاب درسی', shenase: 'WOLRJ', },
        ghesmate6: { onvan: 'جمع و تفریق عددهای صحیح3', shenase: 'QkhUz', },
        ghesmate5: { onvan: 'تشخیص عددهای طبیعی و عددهای صحیح', shenase: 'sHY3X', },
        ghesmate4: { onvan: 'یافتن عددهای صحیح بین دو عدد', shenase: 'WBNsQ', },
        ghesmate3: { onvan: 'جمع و تفریق عددهای صحیح2', shenase: 'dsH4K', },
        ghesmate2: { onvan: 'جمع و تفریق عددهای صحیح', shenase: 'cfSgX', },
        ghesmate1: { onvan: 'قرینه کردن عددها', shenase: 'h2CVJ', },
      },
    },
  },
  payeye9: {
    shomareyeTartibiyePaye: 'نهم',
    tedadeFaslha: 8,

    fasle8: {
      onvaneFasl: 'حجم و مساحت',

      darse3: {
        onvaneDars: 'سطح و حجم',
        ghesmate12: { onvan: 'سطح و حجم 12', shenase: '7XDoF', },
        ghesmate11: { onvan: 'سطح و حجم 11', shenase: '1JL3u', },
        ghesmate10: { onvan: 'سطح و حجم 10', shenase: 'NIhLk', },
        ghesmate9: { onvan: 'سطح و حجم 9', shenase: 'umghY', },
        ghesmate8: { onvan: 'سطح و حجم 8', shenase: 'Fxt4s', },
        ghesmate7: { onvan: 'سطح و حجم 7', shenase: 'NDg2V', },
        ghesmate6: { onvan: 'سطح و حجم 6', shenase: 'nytQc', },
        ghesmate5: { onvan: 'سطح و حجم 5', shenase: '3LHEI', },
        ghesmate4: { onvan: 'سطح و حجم 4', shenase: 'yJ5z9', },
        ghesmate3: { onvan: 'سطح و حجم 3', shenase: 'X4P35', },
        ghesmate2: { onvan: 'سطح و حجم 2', shenase: 'w07gD', },
        ghesmate1: { onvan: 'سطح و حجم 1', shenase: 'X2Ul3', },
      },

      darse2: {
        onvaneDars: 'حجم هرم و مخروط',
        ghesmate6: { onvan: 'حجم هرم و مخروط 6', shenase: 'Vq43g', },
        ghesmate5: { onvan: 'حجم هرم و مخروط 5', shenase: 'xtmge', },
        ghesmate4: { onvan: 'حجم هرم و مخروط 4', shenase: 'KFx73', },
        ghesmate3: { onvan: 'حجم هرم و مخروط 3', shenase: 'pqx6s', },
        ghesmate2: { onvan: 'حجم هرم و مخروط 2', shenase: '0tQVg', },
        ghesmate1: { onvan: 'حجم هرم و مخروط 1', shenase: 'Fe3lT', },
      },

      darse1: {
        onvaneDars: 'حجم و مساحت کره',
        ghesmate5: { onvan: 'حجم و مساحت کره 5', shenase: 'ZBV4q', },
        ghesmate4: { onvan: 'حجم و مساحت کره 4', shenase: 'AofWE', },
        ghesmate3: { onvan: 'حجم و مساحت کره 3', shenase: '3tz5s', },
        ghesmate2: { onvan: 'حجم و مساحت کره 2', shenase: 'LiVQK', },
        ghesmate1: { onvan: 'حجم و مساحت کره 1', shenase: 'W5B0w', },
      },
    },
    fasle7: {
      onvaneFasl: 'عبارت‌های گویا',

      darse3: {
        onvaneDars: 'تقسیم چندجمله‌ای‌ها',
        ghesmate5: { onvan: 'تقسیم چندجمله ای ها 5', shenase: '3DHlb', },
        ghesmate4: { onvan: 'تقسیم چند جمله ای ها 4', shenase: 'pT2eX', },
        ghesmate3: { onvan: 'تقسیم چند جمله ای ها 3', shenase: 'kcCdD', },
        ghesmate2: { onvan: 'تقسیم چندجمله ای ها 2', shenase: 'jrohn', },
        ghesmate1: { onvan: 'تقسیم چند جمله ای ها 1', shenase: 'gUpsQ', },
      },

      darse2: {
        onvaneDars: 'محاسبات عبارت‌های گویا',
        ghesmate8: { onvan: 'محاسبات عبارت های گویا 8', shenase: 'ASaPq', },
        ghesmate7: { onvan: 'محاسبات عبارت های گویا 7', shenase: 'VgsMS', },
        ghesmate6: { onvan: 'محاسبات عبارت های گویا 6', shenase: 'Y90kw', },
        ghesmate5: { onvan: 'محاسبات عبارت های گویا 5', shenase: 'iWc6D', },
        ghesmate4: { onvan: 'محاسبات عبارت های گویا 4', shenase: 'GNwSH', },
        ghesmate3: { onvan: 'محاسبات عبارت های گویا 3', shenase: 'wog7l', },
        ghesmate2: { onvan: 'محاسبات عبارت های گویا 2', shenase: 'Xpbcr', },
        ghesmate1: { onvan: 'محاسبات عبارت های گویا 1', shenase: 'M9hzo', },
      },

      darse1: {
        onvaneDars: 'معرفی و ساده‌کردن عبارت‌های گویا',
        ghesmate7: { onvan: 'معرفی و ساده کردن عبارت های گویا 7', shenase: 'kzGLy', },
        ghesmate6: { onvan: 'معرفی و ساده کردن عبارت های گویا 6', shenase: '3i1Q8', },
        ghesmate5: { onvan: 'معرفی و ساده کردن عبارت های گویا 5', shenase: 'yUikT', },
        ghesmate4: { onvan: 'معرفی و ساده کردن عبارت های گویا 4', shenase: 'GbJm2', },
        ghesmate3: { onvan: 'معرفی و ساده کردن عبارت های گویا 3', shenase: '1cskf', },
        ghesmate2: { onvan: 'معرفی و ساده کردن عبارت های گویا 2', shenase: 'ohSUI', },
        ghesmate1: { onvan: 'معرفی و ساده کردن عبارت های گویا 1', shenase: 't15f6', },
      },
    },
    fasle6: {
      onvaneFasl: 'خط و معادله‌های خطی',

      darse3: {
        onvaneDars: 'دستگاه معادله‌های خطی',
        ghesmate8: { onvan: 'دستگاه معادله های خطی 8', shenase: 'A2GDP', },
        ghesmate7: { onvan: 'دستگاه معادله های خطی 7', shenase: '2RbFI', },
        ghesmate6: { onvan: 'دستگاه معادله های خطی 6', shenase: 'XB6ak', },
        ghesmate5: { onvan: 'دستگاه معادله های خطی 5', shenase: 't3lBg', },
        ghesmate4: { onvan: 'دستگاه معادله های خطی 4', shenase: 'M7xFb', },
        ghesmate3: { onvan: 'دستگاه معادله های خطی 3', shenase: '3AIgw', },
        ghesmate2: { onvan: 'دستگاه معادله های خطی 2', shenase: 'g9ZGB', },
        ghesmate1: { onvan: 'دستگاه معادله های خطی 1', shenase: '1cZIS', },
      },

      darse2: {
        onvaneDars: 'شیب خط و عرض از مبدأ',
        ghesmate8: { onvan: 'شیب خط و عرض از مبدا 8', shenase: 'Zbe2S', },
        ghesmate7: { onvan: 'شیب خط و عرض از مبدا 7', shenase: '3awtN', },
        ghesmate6: { onvan: 'شیب خط و عرض از مبدا 6', shenase: 'qC8HX', },
        ghesmate5: { onvan: 'شیب خط و عرض از مبدا 5', shenase: '9WQ6g', },
        ghesmate4: { onvan: 'شیب خط و عرض از مبدا 4', shenase: 'XzMma', },
        ghesmate3: { onvan: 'شیب خط و عرض از مبدا 3', shenase: 'ZPIoS', },
        ghesmate2: { onvan: 'شیب خط و عرض از مبدا 2', shenase: 'kBbAg', },
        ghesmate1: { onvan: 'شیب خط و عرض از مبدا 1', shenase: 'RUteE', },
      },

      darse1: {
        onvaneDars: 'معادله‌ی خط',
        ghesmate4: { onvan: 'معادله خط 4', shenase: 'DYbml', },
        ghesmate3: { onvan: 'معادله خط 3', shenase: 'Wbr07', },
        ghesmate2: { onvan: 'معادله خط 2', shenase: '8WyFm', },
        ghesmate1: { onvan: 'معادله خط 1', shenase: 'pj7zr', },
      },
    },
    fasle5: {
      onvaneFasl: 'عبارت‌های جبری',

      darse3: {
        onvaneDars: 'نابرابری‌ها و نامعادله‌ها',
        ghesmate10: { onvan: 'نابرابری ها و نامعادله ها 10', shenase: 'YyDjB', },
        ghesmate9: { onvan: 'نابرابری ها و نامعادله ها 9', shenase: 'cPDoV', },
        ghesmate8: { onvan: 'نابرابری ها و نامعادله ها 8', shenase: '01Imy', },
        ghesmate7: { onvan: 'نابرابری ها و نامعادله ها 7', shenase: '6fKri', },
        ghesmate6: { onvan: 'نابرابری ها و نامعادله ها 6', shenase: 'T9VZg', },
        ghesmate5: { onvan: 'نابرابری ها و نامعادله ها 5', shenase: 'Yki3y', },
        ghesmate4: { onvan: 'نابرابری ها و نامعادله ها 4', shenase: '0Ptrk', },
        ghesmate3: { onvan: 'نابرابری ها و نامعادله ها 3', shenase: 'DXlYh', },
        ghesmate2: { onvan: 'نابرابری ها و نامعادله ها 2', shenase: 'DKeXH', },
        ghesmate1: { onvan: 'نابرابری ها و نامعادله ها 1', shenase: 'MrmaD', },
      },

      darse2: {
        onvaneDars: 'چند اتحاد دیگر، تجزیه و کاربردها',
        ghesmate8: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 8', shenase: 'qFwhe', },
        ghesmate7: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 7', shenase: '5s16y', },
        ghesmate6: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 6', shenase: 'DbkMn', },
        ghesmate5: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 5 ', shenase: '3ANPT', },
        ghesmate4: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 4', shenase: 'DpK3R', },
        ghesmate3: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 3', shenase: 'TuvaO', },
        ghesmate2: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 2', shenase: 'iC9Ep', },
        ghesmate1: { onvan: 'چند اتحاد دیگر، تجزیه و کاربردها 1', shenase: 'IlVoq', },
      },

      darse1: {
        onvaneDars: 'عبارت‌های جبری و مفهوم اتحاد',
        ghesmate7: { onvan: 'عبارت های جبری و اتحاد 7', shenase: 'ZJ6U1', },
        ghesmate6: { onvan: 'عبارت های جبری و اتحاد 6', shenase: 'FtqQa', },
        ghesmate5: { onvan: 'عبارت های جبری و اتحاد 5', shenase: 'mqSvJ', },
        ghesmate4: { onvan: 'عبارت های جبری و اتحاد 4', shenase: 'OBgl3', },
        ghesmate3: { onvan: 'عبارت های جبری و اتحاد 3', shenase: 'SoeX9', },
        ghesmate2: { onvan: 'عبارت های جبری و اتحاد 2', shenase: 'MzgEV', },
        ghesmate1: { onvan: 'عبارت های جبری و اتحاد 1', shenase: 'jtHBl', },
      },
    },
    fasle4: {
      onvaneFasl: 'توان و ریشه',

      darse4: {
        onvaneDars: 'جمع و تفریق رادیکال‌ها',
        ghesmate6: { onvan: 'جمع و تفریق رادیکال ها 6', shenase: 'Wh1tZ', },
        ghesmate5: { onvan: 'جمع و تفریق رادیکال ها 5', shenase: 'mkGpS', },
        ghesmate4: { onvan: 'جمع و تفریق رادیکال ها 4', shenase: 'zdb5C', },
        ghesmate3: { onvan: 'جمع و تفریق رادیکال ها 3', shenase: 'yv7NP', },
        ghesmate2: { onvan: 'جمع و تفریق رادیکال ها 2', shenase: 'i3Fah', },
        ghesmate1: { onvan: 'جمع و تفریق رادیکال ها 1', shenase: 'Jahv7', },
      },

      darse3: {
        onvaneDars: 'ریشه‌گیری',
        ghesmate10: { onvan: 'ریشه گیری 10', shenase: 'huUGJ', },
        ghesmate9: { onvan: 'ریشه گیری 9', shenase: 'O9vpy', },
        ghesmate8: { onvan: 'ریشه گیری 8', shenase: 'YOmUq', },
        ghesmate7: { onvan: 'ریشه گیری 7', shenase: 'GoZ3W', },
        ghesmate6: { onvan: 'ریشه گیری 6', shenase: '6CU3G', },
        ghesmate5: { onvan: 'ریشه گیری 5', shenase: 'rEzNs', },
        ghesmate4: { onvan: 'ریشه گیری 4', shenase: 'Q3tLx', },
        ghesmate3: { onvan: 'ریشه گیری 3', shenase: 'W1Fbp', },
        ghesmate2: { onvan: 'ریشه گیری 2', shenase: 'ATywP', },
        ghesmate1: { onvan: 'ریشه گیری 1', shenase: '3cjMN', },
      },

      darse2: {
        onvaneDars: 'نماد علمی',
        ghesmate9: { onvan: 'نماد علمی 9', shenase: 'eZpT5', },
        ghesmate8: { onvan: 'نماد علمی 8', shenase: 'wFMtW', },
        ghesmate7: { onvan: 'نماد علمی 7', shenase: '6vltm', },
        ghesmate6: { onvan: 'نماد علمی 6', shenase: 'JjkLh', },
        ghesmate5: { onvan: 'نماد علمی 5', shenase: 'nBmsK', },
        ghesmate4: { onvan: 'نماد علمی 4', shenase: 'yfsqu', },
        ghesmate3: { onvan: 'نماد علمی 3', shenase: 'YldIi', },
        ghesmate2: { onvan: 'نماد علمی 2', shenase: 'Eches', },
        ghesmate1: { onvan: 'نماد علمی 1', shenase: 'cuflI', },
      },

      darse1: {
        onvaneDars: 'توان صحیح',
        ghesmate10: { onvan: 'توان صحیح 10', shenase: 'shq8b', },
        ghesmate9: { onvan: 'توان صحیح 9', shenase: 'xiNwC', },
        ghesmate8: { onvan: 'توان صحیح 8', shenase: '3bdj0', },
        ghesmate7: { onvan: 'توان صحیح 7', shenase: 'qAJhT', },
        ghesmate6: { onvan: 'توان صحیح 6', shenase: 'v3cwi', },
        ghesmate5: { onvan: 'توان صحیح 5', shenase: '7s8LI', },
        ghesmate4: { onvan: 'توان صحیح 4', shenase: 'ar3lV', },
        ghesmate3: { onvan: 'توان صحیح 3', shenase: 'w0CzQ', },
        ghesmate2: { onvan: 'توان صحیح 2', shenase: 'Kyf5N', },
        ghesmate1: { onvan: 'توان صحیح 1', shenase: '0fNLR', },
      },
    },
    fasle3: {
      onvaneFasl: 'استدلال و اثبات در هندسه',

      darse5: {
        onvaneDars: 'شکل‌های متشابه',
        ghesmate9: { onvan: 'شکل های متشابه 9', shenase: 'IJkh1', },
        ghesmate8: { onvan: 'شکل های متشابه 8', shenase: 'qgDLO', },
        ghesmate7: { onvan: 'شکل های متشابه 7', shenase: 'reICb', },
        ghesmate6: { onvan: 'شکل های متشابه 6', shenase: 'qDlAO', },
        ghesmate5: { onvan: 'شکل های متشابه 5', shenase: 'ECVeG', },
        ghesmate4: { onvan: 'شکل های متشابه 4', shenase: 'EPIh2', },
        ghesmate3: { onvan: 'شکل های متشابه 3', shenase: 'oRF0l', },
        ghesmate2: { onvan: 'شکل های متشابه 2', shenase: 'dMjav', },
        ghesmate1: { onvan: 'شکل های متشابه 1', shenase: '6Ce2r', },
      },

      darse4: {
        onvaneDars: 'حل مسئله در هندسه',
        ghesmate6: { onvan: 'حل مسئله در هندسه 6', shenase: '6ky53', },
        ghesmate5: { onvan: 'حل مسئله در هندسه 5', shenase: 'V45Tb', },
        ghesmate4: { onvan: 'حل مسئله در هندسه 4', shenase: 'ARx19', },
        ghesmate3: { onvan: 'حل مسئله در هندسه 3', shenase: 'YDUGt', },
        ghesmate2: { onvan: 'حل مسئله در هندسه 2', shenase: 'NKPF2', },
        ghesmate1: { onvan: 'حل مسئله در هندسه 1', shenase: '0yhzF', },
      },

      darse3: {
        onvaneDars: 'همنهشتی مثلث‌ها',
        ghesmate8: { onvan: 'هم نهشتی مثلث ها 8', shenase: 'atFlZ', },
        ghesmate7: { onvan: 'هم نهشتی مثلث ها 7', shenase: '25Wuz', },
        ghesmate6: { onvan: 'هم نهشتی مثلث ها 6', shenase: '3hN0m', },
        ghesmate5: { onvan: 'هم نهشتی مثلث ها 5', shenase: 'aWBLq', },
        ghesmate4: { onvan: 'هم نهشتی مثلث ها 4', shenase: 'wRO1A', },
        ghesmate3: { onvan: 'هم نهشتی مثلث ها 3', shenase: 'kgBof', },
        ghesmate2: { onvan: 'هم نهشتی مثلث ها 2', shenase: 'PUzIh', },
        ghesmate1: { onvan: 'هم نهشتی مثلث ها 1', shenase: 'DwG5h', },
      },

      darse2: {
        onvaneDars: 'آشنایی با اثبات در هندسه',
        ghesmate5: { onvan: 'آشنایی با اثبات در هندسه 5', shenase: 'qwpGg', },
        ghesmate4: { onvan: 'آشنایی با اثبات در هندسه 4', shenase: 'L6b0a', },
        ghesmate3: { onvan: 'آشنایی با اثبات در هندسه 3', shenase: 'WoyzZ', },
        ghesmate2: { onvan: 'آشنایی با اثبات در هندسه 2', shenase: '7DLjp', },
        ghesmate1: { onvan: 'آشنایی با اثبات در هندسه 1', shenase: 'Yo2Q5', },
      },

      darse1: {
        onvaneDars: 'استدلال',
      },
    },
    fasle2: {
      onvaneFasl: 'عددهای حقیقی',

      darse3: {
        onvaneDars: 'قدر مطلق و محاسبه‌ی تقریبی',
        ghesmate6: { onvan: 'قدر مطلق 6', shenase: 'YCwbK', },
        ghesmate5: { onvan: 'قدرمطلق 5', shenase: '2Dh4c', },
        ghesmate4: { onvan: 'قدر مطلق 4', shenase: 'dK9pP', },
        ghesmate3: { onvan: 'قدرمطلق 3', shenase: '4avJx', },
        ghesmate2: { onvan: 'قدر مطلق 2', shenase: 'MsIli', },
        ghesmate1: { onvan: 'قدرمطلق 1', shenase: 'BfawE', },
      },

      darse2: {
        onvaneDars: 'عددهای حقیقی',
        ghesmate7: { onvan: 'عددهای حقیقی 3', shenase: 'e5ILm', },
        ghesmate6: { onvan: 'عددهای حقیقی 2', shenase: '7xiJ9', },
        ghesmate5: { onvan: 'عددهای حقیقی 1', shenase: '6NaeU', },
        ghesmate4: { onvan: 'عددهای گنگ 4', shenase: 'etEYH', },
        ghesmate3: { onvan: 'عددهای گنگ 3', shenase: 'Sj9Zc', },
        ghesmate2: { onvan: 'عددهای گنگ 2', shenase: 'vF2sA', },
        ghesmate1: { onvan: 'عددهای گنگ 1', shenase: 'B5Skt', },
      },

      darse1: {
        onvaneDars: 'عددهای گویا',
        ghesmate6: { onvan: 'عددهای گویا 6', shenase: 'jqKad', },
        ghesmate5: { onvan: 'عددهای گویا 5 - مختوم و متناوب', shenase: 'sEWRv', },
        ghesmate4: { onvan: 'عددهای گویا 4', shenase: 'L7h2z', },
        ghesmate3: { onvan: 'عددهای گویا 3', shenase: 'RqYno', },
        ghesmate2: { onvan: 'عددهای گویا 2', shenase: 'XFdU2', },
        ghesmate1: { onvan: 'عددهای گویا 1', shenase: 'LFrdJ', },
      },
    },
    fasle1: {
      onvaneFasl: 'مجوعه‌ها',

      darse4: {
        onvaneDars: 'مجموعه‌ها و احتمال',
        ghesmate2: { onvan: 'مجموعه ها و احتمال 2', shenase: '69CJg', },
        ghesmate1: { onvan: 'مجموعه ها و احتمال 1', shenase: 'AyFiZ', },
      },

      darse3: {
        onvaneDars: 'اجتماع، اشتراک و تفاضلِ مجموعه‌ها',
        ghesmate8: { onvan: 'اجتماع، اشتراک، تفاضل مجموعه ها 8', shenase: '0r7NZ', },
        ghesmate7: { onvan: 'اجتماع، اشتراک، تفاضل مجموعه ها 7', shenase: '3MIfQ', },
        ghesmate6: { onvan: 'اجتماع، اشتراک، تفاضل مجموعه ها 6', shenase: 'Wo4Xt', },
        ghesmate5: { onvan: 'اجتماع، اشتراک، تفاضل مجموعه ها 5', shenase: 'AOUfe', },
        ghesmate4: { onvan: 'اجتماع، اشتراک، تفاضل مجموعه ها 4 ', shenase: 'Z1cHz', },
        ghesmate3: { onvan: 'اجتماع، اشتراک، تفاضل 3 ', shenase: 'Jg5ZD', },
        ghesmate2: { onvan: 'اجتماع، اشتراک، تفاضل 2 ', shenase: '5z4td', },
        ghesmate1: { onvan: 'اجتماع، اشتراک، تفاضل 1 ', shenase: 'vMwah', },
      },

      darse2: {
        onvaneDars: 'مجموعه‌های برابر و نمایش مجموعه‌ها',
        ghesmate5: { onvan: 'مجموعه به زبان ریاضی (2)', shenase: 'Cmrif', },
        ghesmate4: { onvan: 'مجموعه به زبان ریاضی (1)', shenase: 'xL27O', },
        ghesmate3: { onvan: 'نحوه نوشتن زیر مجموعه ها', shenase: 'gPOUe', },
        ghesmate2: { onvan: 'زیر مجموعه', shenase: '5NpMD', },
        ghesmate1: { onvan: 'دو مجموعه‌ی برابر', shenase: 'lTJgs', },
      },

      darse1: {
        onvaneDars: 'معرفی مجموعه‌ها',
        ghesmate9: { onvan: 'مجموعه ها - حل تمرین', shenase: '9QrYG', },
        ghesmate8: { onvan: 'حل یک سوال از فصل اول (مجموعه ها)', shenase: 'Csbnh', },
        ghesmate7: { onvan: 'مجموعه تهی {  }', shenase: 'iKw5l', },
        ghesmate6: { onvan: 'نمودار ون', shenase: 'KTfw6', },
        ghesmate5: { onvan: 'عضویت و عدم عضویت در یک مجموعه', shenase: 'cDIxF', },
        ghesmate4: { onvan: 'جابجایی عضوها در یک مجموعه', shenase: 'lQ85b', },
        ghesmate3: { onvan: 'غیرتکراری بودن اعضا در مجموعه', shenase: 'HgSWk', },
        ghesmate2: { onvan: 'تشخیص مجموعه', shenase: 'LJmf7', },
        ghesmate1: { onvan: 'معرفی مجموعه', shenase: 'HToJZ', },
      },

    },

    fasle0: {
      onvaneFasl: 'متفرقه',
      darse1: {
        onvaneDars: 'متفرقه',
        ghesmate36: { onvan: 'تدریس آنلاین ریاضی نهم', shenase: 'KzgP2', },
        ghesmate35: { onvan: 'فیلم درسی مخصوصِ آموزش آنلاین ریاضی نهم: سطح و حجم', shenase: 'JFDsU', },
        ghesmate34: { onvan: 'فیلم درسی مخصوصِ آموزش آنلاین ریاضی نهم: حجم هرم و مخروط', shenase: '5Uiv4', },
        ghesmate33: { onvan: 'فیلم درسی مخصوصِ آموزش آنلاین ریاضی نهم: حجم و مساحت کره', shenase: 'jXKJo', },
        ghesmate32: { onvan: 'فیلم درسی مخصوصِ آموزش آنلاین ریاضی نهم: تقسیم چند جمله ای ها', shenase: 'hQ2Ge', },
        ghesmate31: { onvan: 'فیلم درسی مخصوصِ آموزش آنلاین ریاضی نهم: محاسبات عبارت های گویا', shenase: 'H0cY1', },
        ghesmate30: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: ساده کردن عبارت های گویا', shenase: 'UYqij', },
        ghesmate29: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: دستگاه معادله های خطی', shenase: 'oXEUK', },
        ghesmate28: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: شیب خط و عرض از مبداء', shenase: 'nXo62', },
        ghesmate27: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: معادله خط', shenase: 'RuTKw', },
        ghesmate26: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: نامعادله', shenase: 'gLuiR', },
        ghesmate25: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: اتحاد مربع دو جمله ای', shenase: 'KfxOi', },
        ghesmate24: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: تجزیه به کمک فاکتورگیری و اتحادها', shenase: 'YD8yO', },
        ghesmate23: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: رادیکال و قدرمطلق', shenase: '3OCWj', },
        ghesmate22: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: ریشه گیری', shenase: '8phvw', },
        ghesmate21: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: نماد علمی', shenase: 'O0Hmd', },
        ghesmate20: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: توانِ صحیح', shenase: 'i0lfV', },
        ghesmate19: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: شکل های متشابه', shenase: 'Rw0IY', },
        ghesmate18: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: حل مسئله در هندسه', shenase: 'EGJs0', },
        ghesmate17: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: هم نهشتی مثلث ها', shenase: 'SYM9l', },
        ghesmate16: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: آشنایی با اثبات در هندسه', shenase: 'gVfr4', },
        ghesmate15: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: استدلال', shenase: 'F86EX', },
        ghesmate14: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: قدر مطلق', shenase: 'yNpeI', },
        ghesmate13: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: عددهای حقیقی', shenase: 'v2WPd', },
        ghesmate12: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: عددهای گویا', shenase: 'Z5L8g', },
        ghesmate11: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: مجموعه ها و احتمال', shenase: 'if25u', },
        ghesmate10: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: اشتراک و تفاضل مجموعه ها', shenase: 'rQvbF', },
        ghesmate9: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: مجموعه‌های برابر و نمایش مجموعه‌ها', shenase: '0IajK', },
        ghesmate8: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: معرفی مجموعه', shenase: 'i3qoV', },
        ghesmate7: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: تجزیه عبارت های جبری', shenase: 'vtZ90', },
        ghesmate6: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: اتحاد مزدوج و جمله مشترک', shenase: 'KM4pV', },
        ghesmate5: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: اتحاد', shenase: 'mi1Hq', },
        ghesmate4: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: اثبات کنید!', shenase: 'jB7YL', },
        ghesmate3: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: نکته‌ای درمورد قدرمطلق', shenase: 'D5eTZ', },
        ghesmate2: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: مجموعه ها', shenase: 'dtxTU', },
        ghesmate1: { onvan: 'فیلم درسی برای آموزش آنلاین ریاضی نهم: جمع و تفریق رادیکال ها', shenase: 'sTN0X', },
      },

    },

  },
};

